// frontend/src/components/layout/VakyaLogo.js
//
// Padma Yantra + OM — Vakya Design System v2 app icon.
// Uses a unique ID suffix to avoid SVG gradient ID collisions if rendered multiple times.
// Background uses solid deep blue — no gradient reference that can break.

let _instanceCount = 0;

export default function VakyaLogo({ size = 44 }) {
  // Stable unique ID per mount — avoids SVG defs collision in the DOM
  const uid = `vl${++_instanceCount}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Vākya"
      style={{ flexShrink: 0, borderRadius: '22.5%' }}
    >
      <defs>
        <radialGradient id={`${uid}_bg`} cx="50%" cy="40%" r="65%">
          <stop offset="0%"   stopColor="#2A5F9E"/>
          <stop offset="100%" stopColor="#0D2140"/>
        </radialGradient>
        <radialGradient id={`${uid}_glow`} cx="50%" cy="50%" r="50%">
          <stop offset="0%"   stopColor="#D4A843" stopOpacity="0.18"/>
          <stop offset="100%" stopColor="#D4A843" stopOpacity="0"/>
        </radialGradient>
      </defs>

      {/* Background */}
      <rect width="120" height="120" fill={`url(#${uid}_bg)`}  rx="27"/>
      <rect width="120" height="120" fill={`url(#${uid}_glow)`} rx="27"/>

      {/* 8-petal lotus — Padma Yantra */}
      <g transform="translate(60,60)">
        {[0,45,90,135,180,225,270,315].map(a => (
          <ellipse
            key={a}
            cx="0" cy="-30" rx="7.5" ry="15"
            fill="none"
            stroke="#D4A843"
            strokeWidth="1.3"
            opacity="0.78"
            transform={`rotate(${a})`}
          />
        ))}
        <circle r="20" fill="none" stroke="#D4A843" strokeWidth="0.9" opacity="0.45"/>
        <circle r="11" fill="#D4A843" opacity="0.09"/>
        <text
          x="0" y="9"
          textAnchor="middle"
          fontFamily="Noto Sans Devanagari, serif"
          fontSize="22"
          fontWeight="400"
          fill="#D4A843"
          opacity="0.96"
        >ॐ</text>
      </g>

      {/* Corner dots */}
      <circle cx="18"  cy="18"  r="2.5" fill="#D4A843" opacity="0.28"/>
      <circle cx="102" cy="18"  r="2.5" fill="#D4A843" opacity="0.28"/>
      <circle cx="18"  cy="102" r="2.5" fill="#D4A843" opacity="0.28"/>
      <circle cx="102" cy="102" r="2.5" fill="#D4A843" opacity="0.28"/>
    </svg>
  );
}
